import { useCallback, useEffect, useMemo } from 'react';
import Page from '../../../components/page/Page';
import useThemeMediaQuery from '../../../../core/hooks/useThemeMediaQuery';
import { Avatar, Button, Paper, Typography } from '@mui/material';
import { useNavigationCore } from '../../../../core/router/navigation';
import CreateDialog from '../../../components/companies/CompanyDialog';
import { Company } from '../../../../core/interfaces/company.interface';
import { useMeCore } from '../../../../core/modules/me';
import { useCompanyCore } from '../../../../core/modules/company';

const MeCompanies = () => {
  const { user, companies: userCompanies, getMeCompanies } = useMeCore();
  const { companies, getCompanies } = useCompanyCore();
  const { goToCompanyMetrics } = useNavigationCore();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (user && user.is_superuser) {
      getCompanies({});
    } else {
      getMeCompanies();
    }
    getMeCompanies();
  }, [getCompanies, getMeCompanies, user]);

  const onSelecting = useCallback((id: string) => {
    goToCompanyMetrics(id);
  }, [goToCompanyMetrics]);

  const companyList = useMemo(() => {
    if (user?.is_superuser) {
      return companies;
    }
    else {
      return userCompanies;
    }
  }, [companies, user?.is_superuser, userCompanies]);

  return (
    <>
      <Page
        content={
          !companyList.length ? (
            <div className="flex flex-1 items-center justify-center h-full">
              <Typography color="text.secondary" variant="h5">
                No hay compañías
              </Typography>
            </div>
          ) : (
            <div className="w-full">
              <div className="w-full my-16 sm:col-span-3 px-24 md:px-32">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-24 w-full min-w-0">
                  {companyList.map((company: Company) => (
                    <Paper
                      className="flex flex-col flex-auto items-center shadow rounded-2xl overflow-hidden cursor-pointer"
                      key={company.id}
                    >
                      <div className="flex flex-col flex-auto w-full p-32 items-center text-center">
                        {company.selectedAvatar ? (
                          <Avatar className="w-112 h-112" src={company.selectedAvatar}></Avatar>
                        ) : (
                          <Avatar className="w-112 h-112">
                            {company.name[0]}
                          </Avatar>
                        )}
                        <Typography className="font-medium">
                          {company.name}
                        </Typography>

                        <Button
                          className="px-16 mt-16 min-w-128"
                          color="secondary"
                          variant="contained"
                          onClick={() => onSelecting(company.id)}
                        >
                          Seleccionar
                        </Button>
                      </div>
                    </Paper>
                  ))}
                </div>
              </div>
            </div>
          )
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CreateDialog />
    </>
  );
};

export default MeCompanies;
